import { SubwayIcon } from './SubwayIcon';

/**
 * author: Google
 * id 769FB684-BA81-4E2A-B623-4C8B6F3DCD2C
 * name subway
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/subway.svg
 * tags
 * - Transportation + Other 
 */
export const UndergroundIcon = SubwayIcon;
export default UndergroundIcon